import Search from './index.vue'
export default [{
    path: '/search',
    name:'search',
    component:Search,
},
{
    path: '',
    redirect: { name: 'search' }
}]